export const en = {
	process_state: {
		error: "Error",
		warning: "Warning",
		pending: "Pending",
		success: "Success",
		unused: "Unused"
	},
	event_entry_type: {
		process: "Process",
		unit_of_work: "Unit Of Work",
		third_party_response: "Third party response",
		event: "Event"
	}
};

export const de = {
	process_state: {
		error: "Fehler",
		warning: "Warnung",
		pending: "Ausstehend",
		success: "Erfolg",
		unused: "Ungenutzt"
	},
	event_entry_type: {
		process: "Prozess",
		unit_of_work: "Unit Of Work",
		third_party_response: "Antwort Drittsystem",
		event: "Event"
	}
};
